// DisclaimerPanel — persistent independent-appraisal disclaimer (F8.3). Presentation.

import { DISCLOSURE } from '../layout/disclaimer';

export function DisclaimerPanel() {
  return (
    <div className="card">
      <div className="card-title">Independent-Appraisal Disclaimer</div>
      <p style={{ fontSize: 'var(--font-size-2)', lineHeight: 1.6 }}>{DISCLOSURE}</p>
    </div>
  );
}
